import { motion } from "framer-motion";
import {
    Flame,
    Users,
    CalendarDays,
    Trophy,
    ArrowRight,
    TrendingUp
} from "lucide-react";

export default function TrendingSidebar({

    trending = [],

    creators = [],

    events = [],

    leaderboard = [],

    onThreadClick,

    onCreatorClick,

    onEventClick,

    onLeaderboardClick

}) {

    return (

        <motion.aside

            initial={{ opacity:0,x:20 }}

            animate={{ opacity:1,x:0 }}

            className="sticky top-24 space-y-6"

        >

            {/* Trending Topics */}

            <GlassCard>

                <div className="flex items-center gap-2 mb-5">

                    <Flame className="text-orange-500"/>

                    <h3 className="font-bold text-lg">

                        Trending Today

                    </h3>

                </div>

                <div className="space-y-4">

                    {

                        trending.map((item,index)=>(

                            <button

                                key={index}

                                onClick={()=>onThreadClick(item)}

                                className="
                                    w-full
                                    text-left
                                    rounded-2xl
                                    p-3
                                    hover:bg-gray-50
                                    transition
                                "

                            >

                                <div className="font-semibold">

                                    #{item.title}

                                </div>

                                <div className="text-sm text-gray-500 mt-1">

                                    {item.posts} discussions

                                </div>

                            </button>

                        ))

                    }

                </div>

            </GlassCard>

            {/* Active Creators */}

            <GlassCard>

                <div className="flex items-center gap-2 mb-5">

                    <Users className="text-blue-500"/>

                    <h3 className="font-bold text-lg">

                        Active Creators

                    </h3>

                </div>

                <div className="space-y-4">

                    {

                        creators.map(user=>(

                            <button

                                key={user.id}

                                onClick={()=>onCreatorClick(user)}

                                className="
                                    w-full
                                    flex
                                    items-center
                                    gap-3
                                    p-2
                                    rounded-2xl
                                    hover:bg-gray-50
                                    transition
                                "

                            >

                                <img

                                    src={user.avatar}

                                    alt=""

                                    className="
                                        w-12
                                        h-12
                                        rounded-full
                                        object-cover
                                    "

                                />

                                <div className="flex-1 text-left">

                                    <div className="font-semibold">

                                        {user.name}

                                    </div>

                                    <div className="text-sm text-gray-500">

                                        {user.followers}

                                    </div>

                                </div>

                                <TrendingUp

                                    className="text-green-500"

                                    size={18}

                                />

                            </button>

                        ))

                    }

                </div>

            </GlassCard>

            {/* Upcoming Events */}

            <GlassCard>

                <div className="flex items-center gap-2 mb-5">

                    <CalendarDays className="text-purple-500"/>

                    <h3 className="font-bold text-lg">

                        Upcoming Events

                    </h3>

                </div>

                <div className="space-y-4">

                    {

                        events.map(event=>(

                            <button

                                key={event.id}

                                onClick={()=>onEventClick(event)}

                                className="
                                    w-full
                                    text-left
                                    rounded-2xl
                                    border
                                    border-gray-100
                                    p-4
                                    hover:bg-gray-50
                                    transition
                                "

                            >

                                <div className="font-semibold">

                                    {event.title}

                                </div>

                                <div className="text-sm text-gray-500 mt-2">

                                    {event.date}

                                </div>

                            </button>

                        ))

                    }

                </div>

            </GlassCard>

            {/* Leaderboard */}

            <GlassCard>

                <div className="flex items-center gap-2 mb-5">

                    <Trophy className="text-yellow-500"/>

                    <h3 className="font-bold text-lg">

                        Top Contributors

                    </h3>

                </div>

                <div className="space-y-3">

                    {

                        leaderboard.map((user,index)=>(

                            <button

                                key={user.id}

                                onClick={()=>onLeaderboardClick(user)}

                                className="
                                    w-full
                                    flex
                                    justify-between
                                    items-center
                                    rounded-2xl
                                    p-3
                                    hover:bg-gray-50
                                    transition
                                "

                            >

                                <div className="flex items-center gap-3">

                                    <div
                                        className="
                                            w-8
                                            h-8
                                            rounded-full
                                            bg-blue-100
                                            flex
                                            items-center
                                            justify-center
                                            font-bold
                                        "
                                    >

                                        {index+1}

                                    </div>

                                    <span>

                                        {user.name}

                                    </span>

                                </div>

                                <ArrowRight size={16}/>

                            </button>

                        ))

                    }

                </div>

            </GlassCard>

        </motion.aside>

    );

}

function GlassCard({children}){

    return(

        <div
            className="
                rounded-[28px]
                bg-white/70
                backdrop-blur-xl
                border
                border-white/30
                shadow-xl
                p-6
            "
        >

            {children}

        </div>

    );

}